import { SortOptions, TripTypes } from '@model/common';
import { useSelector } from 'react-redux';
import { dispatch } from '@state/store';
import {
  getSelectedAirport,
  getSelectedMonth,
  getSelectedSortOption,
  getTripTypeFilter,
  setSelectedAirport,
  setSelectedMonth,
  setSelectedSortOption,
  setTripTypeFilter
} from '@state/slices/navigation';

export default function optionsProps() {
  const selectedOptions = {
    selectedAirport: useSelector(getSelectedAirport),
    selectedMonth: useSelector(getSelectedMonth),
    selectedSortOption: useSelector(getSelectedSortOption),
    selectedFilter: useSelector(getTripTypeFilter)
  };

  const setOptions = {
    setSelectedAirport: (payload: string) => dispatch(setSelectedAirport(payload)),
    setSelectedFilter: (payload: TripTypes) => dispatch(setTripTypeFilter(payload)),
    setSelectedMonth: (payload: string) => dispatch(setSelectedMonth(payload)),
    setSelectedSortOption: (payload: SortOptions) => dispatch(setSelectedSortOption(payload))
  };

  return { selectedOptions, setOptions };
}
